import { ChevronRight, Home } from "lucide-react";

export default function Breadcrumbs({ items = [] }) {
  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-sm text-muted-foreground">
      {items.map((item, index) => (
        <div key={item.label} className="flex items-center gap-2">
          {index > 0 && <ChevronRight className="size-3.5" aria-hidden="true" />}
          {index === 0 && <Home className="size-3.5" aria-hidden="true" />}
          <a
            href={item.href}
            className="transition hover:text-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
          >
            {item.icon && <span className="mr-1">{item.icon}</span>}
            {item.label}
          </a>
        </div>
      ))}
    </nav>
  );
}